module.exports = __webpack_public_path__ + "img/prepRating.8e861c3.svg";